export { DealsTourCardGrid } from "./DealsTourCardGrid";
export { type DealsTourCardGridProps } from "./types";
